import React, { useContext, useEffect, useRef } from 'react'
import Content from '../Layout/Content/Content'
import SearchLocationContext from '../../context/SearchLocationContext'
import ContentWrapper from '../Layout/ContentWrapper/ContentWrapper'
import Sidebar from '../Layout/Sidebar/Sidebar'
import Map from '../GoogleMap/Map/Map'
import LocationList from '../LocationList/LocationList'
import LocationDetails from '../LocationDetails/LocationDetails'
import styles from './LocationsDisplayContainer.module.scss'

const LocationsDisplayContainer = () => {
    const [searchLocationData] = useContext(SearchLocationContext)
    const mapRef = useRef(null)

    // Hide map from screen readers when LocationDetails dialog is open
    useEffect(() => {
        if (mapRef.current) {
            if (searchLocationData.activeLocationId == null) {
                mapRef.current.removeAttribute('aria-hidden')
                mapRef.current.removeAttribute('inert')
            } else {
                mapRef.current.setAttribute('aria-hidden', 'true')
                mapRef.current.setAttribute('inert', '')
            }
        }
    }, [searchLocationData.activeLocationId])

    return (
        <ContentWrapper>
            <Sidebar>{searchLocationData.activeLocationId == null ? <LocationList /> : <LocationDetails />}</Sidebar>
            <Content>
                <div ref={mapRef} className={styles.mapWrapper}>
                    <Map />
                </div>
            </Content>
        </ContentWrapper>
    )
}

export default LocationsDisplayContainer
